import { render, staticRenderFns } from "./ProjetoRNDetalhamento.vue?vue&type=template&id=03f9bb3a&"
import script from "./ProjetoRNDetalhamento.vue?vue&type=script&lang=js&"
export * from "./ProjetoRNDetalhamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports